export const API_URL_LINK = "https://vlmainman.com/api/"
// export const API_URL_LINK = "http://localhost:8000/api/"
